<template>
  <div>
    <el-row
      class="flex-container-balance"
      style="padding-bottom: 0px; margin-bottom: 0px"
    >
      <el-col :span="20">
        <el-row type="flex" justify="end">
          <el-col :span="10" :offset="1">
            <el-select
              size="large"
              v-model="proveedor"
              :loading="this.loading_Balance_Data"
              filterable
              clearable
              placeholder="Proveedores"
              @change="GetClintesByEmpresaid"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in proveedores"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-select
              :disabled="!this.proveedor"
              size="large"
              v-model="cliente"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Clientes"
              @change="this.setCliente"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in clientes"
                :key="index"
                :label="item.Name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-select
              size="large"
              v-model="year"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Año"
              class="supliers_select"
            >
              <el-option
                v-for="(item, index) in years"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <template>
        <rabbey-table-3
          class="MargenSuperior"
          :loading="loading"
          :data="tableData"
          :columns="AuditColumns"
        />
        <DrawerCardStatesChanges
          :Visible="IsVisible"
          @VisibleFalse="HandleNotVisible"
          :mes="mes"
          :year="year"
          :Day="Dia"
          :proveedor="proveedor"
          :cliente="cliente"
          :descripcion="descripcion"
        ></DrawerCardStatesChanges>
      </template>
    </el-row>
  </div>
</template>

<script>
//import DrawerAuditoriaTransactions from "@/views/modules/audit-transactions/Drawers/DrawerAuditoriaTransactions.vue";
//import SaltoComprobanteDrawer from "@/views/modules/audit-transactions/Drawers/SaltoComprobanteDrawer.vue";
import DrawerCardStatesChanges from "@/views/modules/audit-transactions/Drawers/DrawerCardStatesChanges.vue";
import { AuditColumns } from "@/views/modules/audit-transactions/AuditColumns.js";
export default {
  name: "Audit-state",
  components: {
    DrawerCardStatesChanges
    //DrawerAuditoriaTransactions,
    // SaltoComprobanteDrawer,
    // TransaccionNoRegistradaDrawer
  },
  data() {
    return {
      descripcion: null,
      data1: [],
      data2: [],
      IsVisible: false,
      detallesSaltoComrpobanteVisible: false,
      DetallesTransaccionNoRegistradaVisible: false,
      day: 0,
      tableData: [],
      AuditColumns: AuditColumns,
      cliente: null,
      clientes: [],
      proveedor: 0,
      proveedores: [],
      loading_Balance_Data: false,
      loading1: false,
      mes: new Date().getMonth(),
      loading: false,
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      year: new Date().getFullYear(),
      Dia: new Date().getDay(),
      years: [],
      rowValue: 0
    };
  },

  async mounted() {
    await this.getProveedor();
    this.getYears();
    await this.GetCardStatesHistory();
    // await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
  },

  methods: {
    async HandleNotVisible() {
      this.IsVisible = !this.IsVisible;
      await this.GetCardStatesHistory();
    },
    async setCliente() {
      await this.GetCardStatesHistory();
    },
    getYears() {
      let CurrentYear = new Date().getFullYear();

      for (let i = 2010; i <= CurrentYear; i++) {
        this.years.unshift(i);
      }
    },
    async getProveedor() {
      this.loading_Balance_Data = true;
      this.proveedores.push({ Name: "Todos", id: 0 });
      this.$http
        .get(`/api/tennos/GetEmpresas`)
        .then((resp) => {
          resp.data.forEach((element) => {
            this.proveedores.push({
              Name: element.Name,
              id: element.Empresaid
            });
          });
          this.loading_Balance_Data = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    async GetClintesByEmpresaid() {
      if (this.proveedor != 0) {
        this.loading_Balance_Data = true;
        this.clientes = [];

        this.$http
          .get(`/api/tennos/GetClientByEmpresaId/?EmpresaId=${this.proveedor}`)
          .then((resp) => {
            resp.data.forEach((element) => {
              this.clientes.push({
                Name: element.Nombre_Cliente,
                id: element.clienteid
              });
            });
            this.loading_Balance_Data = false;
          });
      }
      this.cliente = null;
      await this.GetCardStatesHistory();
      //   await this.GetDuplicatedTransaccionsAndComprobanteSaltos();
    },

    OpenDetailsDrawer(mes1, descripcion, value) {
      this.descripcion = descripcion;
      this.mes = mes1;

      this.rowValue = value;

      // this.IsVisible = true;
      this.HandleNotVisible();

      return;
    },

    async GetCardStatesHistory() {
      this.tableData = [];
      this.loading = true;

      this.$http
        .get(
          `/api/tennos/GetCardStatusChanged?year=${this.year}&EmpresaId=${this.proveedor}&ClientId=${this.cliente}`
        )
        .then((resp) => {
          // this.tableData.push(this.OpenDetailsDrawer);

          resp.data.forEach(async (element) => {
            element.OpenDetailsDrawer = this.OpenDetailsDrawer;
            element.year = this.year;

            this.tableData.push(element);
          });
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.MargenSuperior {
  margin-top: 3rem;
}
</style>
